export const SALES_MODULE_KEY = 'sales';
export const PURCHASE_MODULE_KEY = 'purchases';
export const DOCUMENT_REPORT_MODULE_KEY = 'document_report';
export const VAT_REPORT_MODULE_KEY = 'vat_report';
export const BULK_UPLOAD_MODULE_KEY = 'bulk_upload';
export const BUSINESS_PROFILES_MODULE_KEY = 'business_profiles';
export const DEVELOPER_DASHBOARD_MODULE_KEY = 'developer_dashboard';

export const EINVOICING_MODULE_KEYS = [
  SALES_MODULE_KEY,
  PURCHASE_MODULE_KEY,
  DOCUMENT_REPORT_MODULE_KEY,
  VAT_REPORT_MODULE_KEY,
  BULK_UPLOAD_MODULE_KEY,
];

export const ROLE_MODULES = [
  {
    key: SALES_MODULE_KEY,
    label: 'Sales',
    tooltip: 'Manage sales invoices, credit notes and customers',
    infoTooltip: true,
  },
  {
    key: PURCHASE_MODULE_KEY,
    label: 'Purchase',
    tooltip: 'Suppliers, Purchase Invoice, Purchase Credit Note, Purchase Register, Product',
    infoTooltip: true,
  },
  {
    key: DOCUMENT_REPORT_MODULE_KEY,
    label: 'Document Reports',
    tooltip: 'To use this permission, the user must also be granted access to either the Sales or Purchase module.',
    infoTooltip: true,
  },
  {
    key: VAT_REPORT_MODULE_KEY,
    label: 'VAT Reports',
    tooltip: 'To use this permission, the user must also be granted access to both Sales and Purchase module.',
    infoTooltip: true,
  },
  {
    key: DEVELOPER_DASHBOARD_MODULE_KEY,
    label: 'Developer Dashboard',
    tooltip:
      'Mutually exclusive with einvoicing modules on the same role — assign a separate role for Sales, Purchase, Document-Report and VAT Report access for selected Business Profiles.',
    infoTooltip: true,
  },
  {
    key: BULK_UPLOAD_MODULE_KEY,
    label: 'Bulk Upload',
    tooltip:
      'Required to view or upload bulk files. Resource permissions (sales, purchases, or register) still apply for each upload type.',
    infoTooltip: true,
  },
];

/** Embedded partner admins can only grant DEVELOPER_DASHBOARD via developer_dashboard. */
export const getVisibleRoleModules = (partnerDashboardOnly = false) => {
  if (!partnerDashboardOnly) {
    return ROLE_MODULES;
  }

  return ROLE_MODULES.filter(({ key }) => key === DEVELOPER_DASHBOARD_MODULE_KEY);
};

export const ACCESS_LEVELS = {
  NONE: 0,
  READ: 1,
  WRITE: 2,
};

export const ACCESS_LEVEL_OPTIONS = [
  { value: ACCESS_LEVELS.NONE, label: 'None' },
  { value: ACCESS_LEVELS.READ, label: 'Read Only' },
  { value: ACCESS_LEVELS.WRITE, label: 'Read & Write' },
];

export const BUSINESS_PROFILE_ACCESS_LEVEL_OPTIONS = [
  { value: ACCESS_LEVELS.READ, label: 'Read Only' },
  { value: ACCESS_LEVELS.WRITE, label: 'Read & Write' },
];

export const buildDefaultPermissions = () => ({
  [SALES_MODULE_KEY]: ACCESS_LEVELS.NONE,
  [PURCHASE_MODULE_KEY]: ACCESS_LEVELS.NONE,
  [DOCUMENT_REPORT_MODULE_KEY]: ACCESS_LEVELS.NONE,
  [VAT_REPORT_MODULE_KEY]: ACCESS_LEVELS.NONE,
  [DEVELOPER_DASHBOARD_MODULE_KEY]: ACCESS_LEVELS.NONE,
  [BULK_UPLOAD_MODULE_KEY]: ACCESS_LEVELS.NONE,
  [BUSINESS_PROFILES_MODULE_KEY]: ACCESS_LEVELS.READ,
});

export const permissionsToMap = (permissions = {}) => {
  const map = buildDefaultPermissions();
  if (permissions && typeof permissions === 'object') {
    ROLE_MODULES.forEach(({ key }) => {
      if (permissions[key] !== undefined && permissions[key] !== null) {
        map[key] = permissions[key];
      }
    });
    if (permissions[BUSINESS_PROFILES_MODULE_KEY]) {
      map[BUSINESS_PROFILES_MODULE_KEY] = permissions[BUSINESS_PROFILES_MODULE_KEY];
    }
  }
  return map;
};

export const mapToPermissionsPayload = (accessMap) => {
  const payload = {};
  ROLE_MODULES.forEach(({ key }) => {
    payload[key] = accessMap[key] ?? ACCESS_LEVELS.NONE;
  });
  payload[BUSINESS_PROFILES_MODULE_KEY] = accessMap[BUSINESS_PROFILES_MODULE_KEY] ?? ACCESS_LEVELS.NONE;
  return payload;
};

export const isEinvoicingModuleActive = (permissionMap = {}) =>
  EINVOICING_MODULE_KEYS.some((key) => (permissionMap[key] ?? ACCESS_LEVELS.NONE) > ACCESS_LEVELS.NONE);

export const applyDeveloperDashboardSelection = (permissionMap, level) => {
  const next = { ...permissionMap, [DEVELOPER_DASHBOARD_MODULE_KEY]: level };
  if (level > ACCESS_LEVELS.NONE) {
    EINVOICING_MODULE_KEYS.forEach((key) => {
      next[key] = ACCESS_LEVELS.NONE;
    });
    next[BUSINESS_PROFILES_MODULE_KEY] = ACCESS_LEVELS.READ;
  }
  return next;
};

export const applyEinvoicingModuleSelection = (permissionMap, moduleKey, level) => ({
  ...permissionMap,
  [moduleKey]: level,
  [DEVELOPER_DASHBOARD_MODULE_KEY]: ACCESS_LEVELS.NONE,
});
